// TODO This is actually an Org User object not a user.  In the future we need to refactor everywhere this is used to differentiate this from a User

import _pick from 'lodash/pick';
import { getGlobalProps } from '../utils/queryHelpers';

const FIELDS = [
  'id',
  'firstName',
  'lastName',
  'roleId',
  'phone',
  'email',
  'active',
  'rowVersion',
  'orgId'
];

const User = () => {
  const {
    orgInfo: { orgId }
  } = getGlobalProps();

  return {
    id: null,
    active: true,
    firstName: '',
    lastName: '',
    email: '',
    roleId: '',
    phone: '',
    orgId
  };
};

export const sanitize = values => {
  const { id, rowVersion, orgId, roleId, ...initialValues } = _pick(
    values,
    FIELDS
  );
  if (id) {
    return {
      id,
      roleId,
      rowVersion
    };
  }
  return {
    ...initialValues,
    roleId,
    orgId
  };
};

export default User;
